import React from 'react';
import {useComponent} from '../component-library';
import {useFeatureAppId} from '../utils/use-feature-app-id';
import {GraphicRadioButton} from './graphic-radio-button';
import {GraphicRadioButtonRow} from './graphic-radio-button-row';
import {IconName} from '../types';
import {generateTestId, TestIdElementType} from '../utils/test';
import {ChargingLocation} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';

export interface ChargingLocationSelectionProps {
  value: ChargingLocation;
  locationLabelHome: string;
  locationLabelWork: string;
  locationLabelPublic: string;
  locationLabelHighway: string;
  onChange: (newValue: ChargingLocation) => void;
  name: string;
  questionTextId: string;
}

export const ChargingLocationSelection: React.FC<ChargingLocationSelectionProps> =
  React.memo((props: ChargingLocationSelectionProps) => {
    const {value, onChange, name, questionTextId} = props;
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      e.stopPropagation();
      onChange(e.target.value as ChargingLocation);
    };

    const Icon = useComponent('Icon');

    //TODO: The data needs to be used from the ACS-config
    const locations = ['atHome', 'atWork', 'atPublic', 'atHighway'];
    const featureAppId = useFeatureAppId();

    return (
      <GraphicRadioButtonRow>
        {locations.map((location) => {
          const locationBaseName = location.replace('at', '');
          const iconName = `Location${locationBaseName}` as IconName;
          const iconMobile = <Icon name={iconName} size="small" ariaHidden />;
          const iconDesktop = <Icon name={iconName} size="medium" ariaHidden />;
          const content = props[
            `locationLabel${locationBaseName}` as keyof ChargingLocationSelectionProps
          ] as string;

          return (
            <GraphicRadioButton
              key={location}
              value={location}
              iconMobile={iconMobile}
              iconDesktop={iconDesktop}
              content={content}
              selected={value === location}
              onChange={handleChange}
              name={name}
              questionTextId={questionTextId}
              testId={generateTestId({
                featureAppId,
                elementName: `charging-location-${locationBaseName.toLowerCase()}`,
                elementType: TestIdElementType.button,
              })}
            />
          );
        })}
      </GraphicRadioButtonRow>
    );
  });

ChargingLocationSelection.displayName = 'ChargingLocationSelection';
